import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBlogCategoryByIdFn, patchBlogCategoryFn, postBlogCategoryFn } from 'Services/Blog';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';

const AddUpdateBlogCategory = () => {
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: getBlogCategoryByIdResponse } = useQuery({
        queryKey: ['get-category-by-id', id, status],
        queryFn: () => getBlogCategoryByIdFn(id),
        enabled: !!id && status === "update"
    })
    const data = getBlogCategoryByIdResponse?.data?.data[0];

    const { mutate: post } = useMutation(postBlogCategoryFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/blog/category')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const { mutate: patch } = useMutation(patchBlogCategoryFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/blog/category')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const initialValues = {
        image: "",
        name: data?.name || "",
    }

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (!values.name) return toast.error("Name is required.")

            const formData = new FormData();
            formData.append('name', values.name);

            if (status === 'add') {
                if (!values.image) return toast.error("Image is required.")
                formData.append('image', values.image);
                post(formData);
            } else {
                if (values.image) formData.append('image', values.image);
                formData.append("blog_category_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div>
            <form
                className="w-[500px] bg-white shadow-md rounded-lg mx-auto p-4 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl !text-black font font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Category
                </p>
                <CustomInput formik={formik} label={"Name"} name={"name"} />
                <ImageInput formik={formik} label={"Image"} name={"image"} />
                <Button
                    type='submit'
                    variant='contained'
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    )
}

export default AddUpdateBlogCategory;